// https://www.sanwebe.com/2013/05/chat-using-websocket-php-socket
// This file connects to the chat-socket-daemon as a client

const host = window.location.host;
const webSocketPort = window.location.protocol === 'https:' ? '' : ':8999';
const webSocketScheme = window.location.protocol === 'https:' ? 'wss://' : 'ws://';
const webSocketUri = webSocketScheme + host + webSocketPort + '/';
const socketClientDebug = true;

let webSocket = null;

window.connectNotificationsSocket = function() {

	var webSocket = new WebSocket( webSocketUri );

	//Connected to server
	webSocket.onopen = function( e ) {
		window.vmHeader.setNotificationsSocketStatus( 'Connected' );

		if ( socketClientDebug )
			console.log( 'Connected to Server' );
	}

	//Connection close
	webSocket.onclose = function( e ) {
		window.vmHeader.setNotificationsSocketStatus( 'Disconnected' );

		if ( socketClientDebug )
			console.log( 'Disconnected from Server' );
	};

	//Message Receved
	webSocket.onmessage = function( e ) {
		if ( socketClientDebug )
			console.log( 'Message received', e, e.data );

		try {
			const data = JSON.parse( e.data );
			if ( data.type === undefined || data.type === null ) { return; }
			console.log({data, e});
			switch (data.type) {
				case 'updated': {
					if ( 'fieldName' in data ) {
						const fieldName = data.fieldName;
						LocalStorageManager.updateField( fieldName );
						if ( socketClientDebug )
							console.log( 'The notification server has triggered an update request: ' + fieldName );
					}
				}
				break;
				case 'system': {
					if ( 'action' in data && data.action === 'restart' ) {
						setTimeout( window.connectNotificationsSocket, 5000 );
						window.vmHeader.setNotificationsSocketStatus( 'Reconnecting in 5 seconds' );
					}
				}
				break;
			}
		} catch ( ex ) {
			let data = null;
			try {
				data = JSON.parse(e.data)
			} catch(e) {
				data = 'data' in e ? e.data : null;
			}
			console.log( 'Could not parse message', ex, e, data );
		}
	};

	//Error
	webSocket.onerror = function( e ) {
		window.vmHeader.setNotificationsSocketStatus( 'Error' );
		console.log( e );
	};

	window.broadcastLocalStorageUpdateRequest = function( fieldName ) {
		if ( socketClientDebug )
			console.log( 'in window.broadcastLocalStorageUpdateRequest( ' + fieldName + ')' );

		webSocket.send( '{"type":"updated","fieldName":"' + fieldName + '"}' );
	}

}
